import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { PropertiesCard } from '../../../../components/Cards/PropertiesCard';
import './DeleteTypeSeriesDialog.css';


const DeleteTypeSeriesDialog = ({ aircraft, onClose, onDelete }) => {
  const computedPart = useMemo(() => ({
    Type: aircraft?.type,
    Series: aircraft?.series,
  
  }), [aircraft]);

  const deleteHandler = (e) => {
    onClose(e);
    onDelete(e);
  }

  return (<div className='delete-aircraft-dialog-component'>
    <div className='header'>
      <span>Are you sure you want to delete this Type/Series?</span>
      {/* <button className='outlined icon mid-size' onClick={onClose}>
        <i className='icon-cross'></i>
      </button> */}

    </div>
    <PropertiesCard singleCard object={computedPart} className='grey'></PropertiesCard>
    <div className='buttons'>
      <button className='filled mid-size' onClick={onClose}>Cancel</button>
      <button className='filled mid-size danger' onClick={deleteHandler}>Delete</button>
    </div>
  </div>)
}


export default DeleteTypeSeriesDialog;